import React, { useEffect, useRef, useState } from 'react';
import { Container, Fade, Typography } from '@mui/material';
import YoutubePlayer from '../../molecules/youtube-player/youtubePlayer';
import './seccionVideo.scss';

export interface ISeccionVideoProps {
    title: string;
    video: string;
}

const SeccionVideo = ({ title, video }: ISeccionVideoProps) => {
    const [isVisible, setIsVisible] = useState(false);
    const SeccionVideoRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setIsVisible(entries[0].isIntersecting);
            }
        });
        if (SeccionVideoRef.current) {
            observer.observe(SeccionVideoRef.current);
        }
        return () => observer.disconnect();
    }, []);
    
    return (
        <Fade in={isVisible} timeout={1500}>
            <Container
                component="section"
                className="o-seccion-video"
                ref={SeccionVideoRef}
            >
                <Typography
                    variant="h2"
                    dangerouslySetInnerHTML={{
                        __html: title,
                    }}
                    className="o-seccion-video__title"
                />
                <div className="o-seccion-video__video">
                    <YoutubePlayer youtubeId={video} />
                </div>
            </Container>
        </Fade>
    );
};

export default SeccionVideo;
